let localization = {
  loginPage: {
    loginTitle: 'Registrazione dello studio',
    loginSubtitle: 'Effettua il login con il tuo account di Migraine Buddy',
    googleLogin: 'Accedi con Google',
    emailLogin: 'Accedi con l\'email',
    or: 'O',
    email: 'Email di Migraine Buddy',
    password: 'Migraine Buddy password',
    downloadInstructionTitle: 'Non hai un account di Migraine Buddy?',
    downloadInstructionBody:
      `1. Scarica Migraine Buddy su <a style="color: white; text-decoration: underline;" href="https://play.google.com/store/apps/details?id=com.healint.migraineapp&referrer=utm_source=squarestudy" target="_blank">Android</a> o <a style="color: white; text-decoration: underline;" href="https://itunes.apple.com/app/apple-store/id975074413" target="_blank">iOS</a>
      <br>
      2. Crea un account con la tua email`
  },
  consentPage: {
    consentTitle: 'Consenso allo studio',
    consentBody: 'La preghiamo di confermare la sua partecipazione allo studio SQUARE e di aver letto e firmato il modulo di consenso informato fornito dal medico dello studio. Se sceglie di connettere l\'app Migraine Buddy allo studio SQUARE, i suoi dati codificati verranno condivisi con Novartis tramite Migraine Buddy come indicato nelle informazioni per il paziente e nel modulo di consenso informato.',
    agree: 'Sono d\'accordo',
    disagree: 'Non sono d\'accordo'
  },
  studyIdentifier: {
    studyIdentifierTitle: 'La preghiamo di inserire il suo numero di paziente che li é stato fornito dal suo medico.',
    studyIdentifierLabel: 'Numero di paziente',
    studyGenderLabel: 'Genere',
    studyGenderMale: 'Maschio',
    studyGenderFemale: 'Femmina',
    // studyIdentifierConfirmationTitle: 'Please check that this Study Identifier is correct',
    confirmationTitle: 'Si prega di verificare che le informazioni siano corrette'
  },
  consentManagement: {
    studyName: 'Studio SQUARE',
    studyDescription: `<p>Il vostro conto Migraine Buddy é adesso collegato con lo studio SQUARE.</p>
    <p>Con questo progetto, vorremmo valutare l'impatto del farmaco Aimovig sulla qualità della vita dei pazienti affetti da emicrania in Svizzera.</p>`,
    withdrawConsent: 'Ritirare il consenso',
    successWithdrawMessage: 'Hai revocato con successo il tuo consenso a collegare l\'app Migraine Buddy allo studio.',
    withdrawConfirmationHeader: 'Ritirare il consenso',
    withdrawConfirmationBody: 'Lei sta revocando il suo consenso a utilizzare i suoi dati dell\'app Migraine Buddy per lo studio SQUARE. Tutti i dati raccolti fino a questo punto saranno comunque analizzati come indicato nel modulo di consenso informato che ha firmato. Se desidera ritirare il suo consenso per l\'intero studio, la preghiamo di mettersi in contatto con il suo medico dello studio.',
    contactInfo: 'Se ha domande sullo studio, la preghiamo di contattare il medico indicato nelle informazioni per il paziente.'
  },
  global: {
    confirm: 'Confermare',
    back: 'Indietro',
    next: 'Il prossimo'
  },
  genericMessages: {
    doNotRefresh: 'Per disconnettersi, si prega di aggiornare la pagina.',
    genericErrorHeader: 'Scusate! Sembra che qualcosa sia andato storto.',
    genericErrorBody: `<p>Si prega di contattare <a href="mailto:jenny@healint.com" class="primary-color"><u>jenny@healint.com</u></a> o riprovare più tardi.</p>`
  },
  errorMessages: {
    invalidEmail: 'Inserisci una email valida',
    emptyPassword: 'Please key in your Migraine Buddy password',
    invalidCredentials: 'Per favore inserisci la tua password di Migraine Buddy.',
    emptyStudyIdentifier: `<p>Per favore inserisci il tuo numero di paziente.</p>`,
    invalidStudyIdentifier: `<p>Si prega di verificare che il formato del proprio numero di paziente sia corretto.</p>`,
    emptyStudyGender: `<p>Per favore indica il tuo sesso.</p>`
  }
}

export default localization



// WEBPACK FOOTER //
// ./src/store/localization/itLocalization.js